/** Capture the initiating session. Support content must never be replayed under another account. */
export function proSupportRequestConfig(
  state: { token: string | null; user: { sub: string } | null },
  owner: string,
) {
  if (!state.token || state.user?.sub !== owner) throw new Error("계정이 변경되었습니다.");
  return { headers: { Authorization: `Bearer ${state.token}` }, _retry: true };
}
